import { Column, Columns } from '@dixa/lib-shared-habla';
import { PropsWithChildren } from 'lib-shared-types-utils';

import { ConditionFieldLayoutEmpty } from './components/empty/conditionFieldLayoutEmpty';
import { ConditionFieldLayoutItem } from './components/item/conditionFieldLayoutItem';
import { ConditionFieldLayoutLoading } from './components/loading/conditionFieldLayoutLoading';
import { ConditionFieldLayoutRow } from './components/row/conditionFieldLayoutRow';

export const ConditionFieldLayout = ({
  children,
}: PropsWithChildren): JSX.Element => (
  <Columns>
    <Column size="300px">{children}</Column>
  </Columns>
);

ConditionFieldLayout.Item = ConditionFieldLayoutItem;
ConditionFieldLayout.Row = ConditionFieldLayoutRow;
ConditionFieldLayout.Empty = ConditionFieldLayoutEmpty;
ConditionFieldLayout.Loading = ConditionFieldLayoutLoading;
